import { createConsoleLogger, createRumLogger } from "@amzn/aws-tc-xb-xps";
import { Logger, LoggerContext, useEnvironment } from "@amzn/xb-hooks";
import { ReactNode } from "react";
import { useConfig } from "../../hooks";

export const UseLoggerHookProvider = ({ children }: { children: ReactNode }) => {
  const { xbAppName } = useConfig();
  const { isDev } = useEnvironment();

  const logger: Logger = isDev() ? createConsoleLogger({}) : createRumLogger({ xbAppName });

  return <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>;
};
